import React, {Component} from "react";
import {Form, Steps, Button, Row, Col, Divider, message} from 'antd';
import NHFetch from '../../../../utils/NHFetch';
import PropTypes from "prop-types";
import style from '../index.css';
import FirstStep from './step-first';
import SeconedStep from './step-second';
import LastStep from './step-last';

const basicUrl = "/hjgl/"; //基础路径
const Step = Steps.Step;

/**
 * 环节管理表单
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-03-14 11:30:47
 * Version: 1.0
 * Modify log:
 */
class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isUpdate: false, //是否是更新操作
            current: 0, //当前步骤
            hjxxData: {}, //配置的环节信息
            hjywxData: [], //配置的环节业务项信息
            isSuccess: false, //是否配置成功
        }
    }

    /*编辑时，初始化数据*/
    componentDidMount() {
        if (this.props.initFormData) {
            const initFormData = this.props.initFormData;
            const hjywxData = initFormData.hjywxVOs;
            for (let key in hjywxData) {
                hjywxData[key].editable = true; //编辑模式
                const ywxdyVO = hjywxData[key].ywxdyVO;
                hjywxData[key].ywxid = ywxdyVO.pkid;
                hjywxData[key].zdmc = ywxdyVO.zdmc;
                hjywxData[key].kjcs = ywxdyVO.kjcs;
            }
            this.setState({isUpdate: true, hjxxData: initFormData.hjdyVO, hjywxData: hjywxData})
        }
    }

    //下一步
    next = () => {
        const current = this.state.current + 1;
        if (this.state.current == 0) {
            //校验、缓存第一步的流程配置数据
            this.saveHjxx(current);
        } else {
            this.setState({current});
        }
    }

    //上一步
    prev = () => {
        const current = this.state.current - 1;
        this.setState({current});
    }

    //校验、缓存第一步的环节信息
    saveHjxx = (current) => {
        const hjxxForm = this.firstStepForm;
        hjxxForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            const hjxxData = this.state.hjxxData;
            this.setState({hjxxData: {...hjxxData, ...formData}});
            this.setState({current});
        });
    }

    //环节配置信息改变时回调
    handleHjxxChange = (values) => {
        this.setState({hjxxData: {...this.state.hjxxData, ...values}});
    }

    //环节业务项配置信息改变时回调
    handleHjywxChange = (hjywxData) => {
        this.setState({hjywxData: hjywxData});
    }

    //完成
    handleFinish = () => {
        let formData = {};
        formData = {hjxxMap: {...this.state.hjxxData}, hjywxList: [...this.state.hjywxData]};

        if (this.state.isUpdate) {
            NHFetch(basicUrl + 'update', 'POST', formData)
                .then(res => {
                    if (res) {
                        if (res.data == 1) {
                            this.setState({isSuccess: true});
                        }
                        this.next();
                    }
                });
        } else {
            NHFetch(basicUrl + 'insert', 'POST', formData)
                .then(res => {
                    if (res) {
                        if (res.data == 1) {
                            this.setState({isSuccess: true});
                        }
                        this.next();
                    }
                });
        }

    }

    //是否继续添加（重新配置）
    handleReset = () => {
        this.setState({
            isUpdate: false, //是否是更新操作
            current: 0, //当前步骤
            hjxxData: {}, //配置的环节信息
            hjywxData: [], //配置的环节业务项信息
            isSuccess: false, //是否配置成功
        });
    }

    //步骤一内容
    getFirstContent() {
        return <FirstStep ref={(form) => this.firstStepForm = form} onChange={this.handleHjxxChange}
                          initFormData={this.state.hjxxData}/>;
    }

    //步骤二内容
    getSecondContent() {
        return <SeconedStep data={this.state.hjywxData} hjxxData={this.state.hjxxData} onChange={this.handleHjywxChange}/>
    }

    //最后一步内容
    getLastContent() {
        return <LastStep update={this.state.isUpdate} status={this.state.isSuccess} onReset={this.handleReset}/>
    }

    render() {

        const {form, initFormData} = this.props;
        const {current} = this.state;

        const steps = [{
            title: '环节定义',
            content: this.getFirstContent(),
            description: '说明：迎新环节名称不宜过长，名称含义应简短明确。'
        }, {
            title: '配置环节业务项',
            content: this.getSecondContent(),
            description: '说明：设置环节中需要填写的业务信息。'
        }, {
            title: '完成',
            content: this.getLastContent(),
        }];

        return (
            <div>
                <Row type="flex" justify="center">
                    <Col span={24}>
                        <Steps current={current}>
                            {steps.map(item => <Step key={item.title} title={item.title}/>)}
                        </Steps>
                        <div className={style["steps-content"]}>
                            {steps[this.state.current].content}
                        </div>
                        <div className={style["steps-action"]}>
                            {
                                this.state.current > 0 && this.state.current < steps.length - 1
                                &&
                                <Button style={{marginRight: 8}} onClick={this.prev}>
                                    上一步
                                </Button>
                            }
                            {
                                this.state.current < steps.length - 2
                                &&
                                <Button type="primary" style={{marginRight: 8}} onClick={this.next}>下一步</Button>
                            }
                            {
                                this.state.current === steps.length - 2
                                &&
                                <Button type="primary" onClick={this.handleFinish}>完成</Button>
                            }
                        </div>
                        {
                            this.state.current < steps.length - 1 ? <Divider/> : null
                        }
                        <div className={style["steps-description"]}>
                            <p>{steps[this.state.current].description}</p>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

EditInitForm.propTypes = {
    initFormData: PropTypes.object, //初始数据
}

const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/lcgl/hjgl/edit-form/EditForm.js